import { useUser } from "../context/UserContext";

export const PERMISSIONS = {
    config: "config",
    locale: "locale",
    ingestion: "ingestion",
    metadata: "metadata",
    mam: "mam",
    curation: "curation",
    genre: "genre",
    slate: "slate",
    dsar: "dsar",
};

export const ACTION = {
    EDIT: "edit",
    VIEW: "view",
};

export const ROLE = {
    ADMIN: "admin",
    STANDARD: "standard",
};

export const usePermissions = () => {
    const { user, role, loading } = useUser();

    const hasPermission = (permission: string, action: string) => {
        if (loading) return false;
        const check =
            (user[`custom:${action}_permissions`] &&
                user[`custom:${action}_permissions`].includes(permission)) ||
            false;
        return check;
    };

    const hasRole = (requiredRole: string) => {
        if (loading) return false;
        return role === requiredRole;
    };

    return { hasPermission, hasRole };
};
